// extracted by mini-css-extract-plugin
export default {"container":"footer_container__WeoWP","text":"footer_text__dyD3v"};